import { FlashAlertOutlineIcon } from './FlashAlertOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 2770517A-B0A3-4AC5-A6E6-6EFD9DA2C3E5
 * name flash-alert-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flash-alert-outline.svg
 * tags
 * - Weather 
 * - Alert / Error 
 */
export const LightningAlertOutlineIcon = FlashAlertOutlineIcon;
export default LightningAlertOutlineIcon